module.exports = Em.Handlebars.compile("{{label}}\n");